import jwt_decode from 'jwt-decode';
import {Roles} from "@/Enums"
import {ActivatedPolicies} from "@/authorization/ActivatedPolicies";
import {Claims} from "@/authorization/constants/JwtClaimConstants";

export class RoleManager{
    
    public static GeneratePermissionMap(jwt:string)
    {
        let userRoles = this.getRolesFromJwt(jwt) as Array<string>;
        let policyMap = new Map();
        ActivatedPolicies.PolicyArray.forEach(element => {
            let restrictions = element.GetPermissions();
            let permissionMap = new Map();
            element.PermissionSets.forEach(permission => {
                let restrictedRoles = restrictions.get(permission) as Array<Roles>;
                permissionMap.set(permission, this.checkCommonEntries(userRoles, restrictedRoles));
            });
            policyMap.set(element.Name, permissionMap);
        });
        return policyMap;
    }

    private static getRolesFromJwt(jwt : string)
    {
        return Object.values(jwt_decode(jwt))[Claims.userRoles];
    }

    private static checkCommonEntries(userRoles:Array<string> , policyRoles:Array<Roles> ){
        let hasPermissions = false;
        policyRoles.forEach(element => {
            let policyRole = Roles[element];
            if(userRoles.includes(policyRole)){
                hasPermissions = true;
            }
        });
        return hasPermissions;
    }

}
